<template>
  <div class="wrapper_dark" @click="interactCheck" @touchstart="interactCheck" @touchmove="interactCheck">
    <div class="header">
      <button class="btn_back" @click="back">
        <img src="@/assets/img/left-arrow.svg" />
      </button>
      <h1 class="title">{{ $tc("confirm_input") }}</h1>
      <button class="btn_exit" @click="goHome">{{ $tc("cancle") }}</button>
    </div>

    <div class="inner_wrap">
      <!-- 메뉴 + 요청사항 모두 사용하는 경우 -->
      <div v-if="(restaurant.menuRequired && selectedMenus.length > 0) && (!isNoRequestList && clientRequestList.length > 0)" class="contents-wrap all-show">
        <!-- 고객정보 + 메뉴정보 + 요청사항 -->
         <div class="customer-and-menu-wrap" :class="{useRequest: !isNoRequestList}">
          <div class="customer-wrap">
            <div class="description-wrap">
              <div class="title" v-html="displayDescriptionTitle"></div>
              <div class="body" v-html="$tc('confirm_03_description_body')"></div>
            </div>
            <div class="customer-info" :class="{ wrap: usePersonnelTypes }">
              <div v-show="waitingParams.name" class="name">
                <text-ellipsis>{{ waitingParams.name }}</text-ellipsis>
              </div>
              <div v-show="waitingParams.name || waitingParams.email" class="vertical-divider"></div>
              <div v-show="waitingParams.phoneNumber" class="phone">{{ displayPhoneNumber }}</div>
              <div v-show="waitingParams.phoneNumber || waitingParams.email" class="vertical-divider"></div>
              <div v-show="waitingParams.email" class="email">{{ waitingParams.email }}</div>
              <div v-show="waitingParams.email || waitingParams.email" class="vertical-divider"></div>
              <!-- TB-14763: 인원 유형 사용 매장은 "유형명 N • 유형명 N" 형태, 길어지면 다음 줄로 -->
              <div v-if="usePersonnelTypes" class="people types">
                <template v-for="(type, idx) in selectedPersonnelTypes">
                  <span v-if="idx > 0" :key="`dot_${idx}`" class="dot">•</span>
                  <span :key="`type_${idx}`">{{ getMultiLanguageName(type, locale) }} {{ Number(type.count) || 0 }}</span>
                </template>
              </div>
              <div v-else class="people" v-html="displayPeopleNum"></div>
            </div>
          </div>
          <!-- 메뉴정보 -->
          <div class="menu-wrap">
            <div class="total-price">
              <div class="text">{{ $tc('orderAmount') }}</div>
              <div class="price">{{ $tc('won', selectedMenusTotalPrice) }}</div>
            </div>
            <hr class="divider">
            <div class="selected_menus">
              <div v-for="(menu, idx) in selectedMenus" :key="`${menu._id}_${idx}`" class="item">
                <div class="menu-name">
                    <text-ellipsis >{{ menu.name }}</text-ellipsis>
                    <div class="menu-quantity">{{ $tc('textOfOptionAddButton', menu.quantity) }}</div>
                </div>
                <div class="menu-size">{{ ` • ${$tc('size')}: ${menu.size.name} ${menu.size.price !== 0 ? `(${$tc('won', menu.size.price)})` : ''}` }}</div>
                <div v-show="(menu.options.length > 0)" class="menu-options">{{ ` • ${$tc('option')}: ${displayOptionsOneLine(menu)}` }}</div>
                <!-- <div class="selected_menu_title">
                  <div class="menu-name">
                    <text-ellipsis >{{ menu.name }}</text-ellipsis>
                  </div>
                  <div class="menu-quantity">{{ menu.quantity }}</div>
                </div>
                <div class="selected_menu_size">{{ ` • ${$tc('size')}: ${menu.size.name} ${menu.size.price !== 0 ? `(${$tc('won', menu.size.price)})` : ''}` }}</div>
                <div v-show="(menu.options.length > 0)" class="selected_menu_options">{{ ` • ${$tc('option')}: ${displayOptionsOneLine(menu)}` }}</div> -->
              </div>
            </div>
          </div>
         </div>
        <!-- 요청사항 -->
        <div v-if="!isNoRequestList" class="request_wrap">
          <div class="title" v-html="$tc('selectRequest')"></div>
          <hr class="divider">
          <div class="requests">
            <div v-for="request in clientRequestList" :key="request.idx" class="item"
            @click="selectRequest(request)">
              <div class="check-box" :class="{selected: request.isSelected}"></div>
              <div class="label">{{ getMultiLanguageName(request, locale) }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 메뉴, 요청사항 중 1개 혹은 전부 사용하지 않는 매장 -->
      <div v-else class="contents-wrap no-all-show">
        <div class="description-wrap">
          <div class="title" v-html="displayDescriptionTitle"></div>
          <div class="body" v-html="$tc('confirm_03_description_body')"></div>
        </div>
        <div class="info-wrap">
          <!-- 고객 요청사항 혹은 메뉴 선택 여부에 따라 노출되는 컴포넌트 변경 -->
          <div class="customer-wrap" :class="{useFlex: (restaurant.menuRequired && selectedMenus.length > 0) || (!isNoRequestList && clientRequestList.length > 0), useTypes: usePersonnelTypes}">
            <div v-if="waitingParams.name" class="item name">
              <div v-html="nameLabel"></div>
              <text-ellipsis >{{ waitingParams.name }}</text-ellipsis>
            </div>
            <hr v-if="waitingParams.name" class="divider">
            <div v-if="waitingParams.phoneNumber" class="item phone">
              <div v-html="$tc('confirm_10_phone')"></div>
              {{ displayPhoneNumber }}
            </div>
            <hr v-if="waitingParams.phoneNumber" class="divider">
            <div v-if="waitingParams.email" class="item email">
              <div v-html="$tc('confirm_11_email')"></div>
              {{ waitingParams.email }}
            </div>
            <hr v-if="waitingParams.email" class="divider">
            <div class="people-wrap">
              <div class="item">
                <div v-html="$tc('confirm_12_people')"></div>
                {{ $tc('confirm_08_number_of_people', this.waitingParams.numOfPeople + this.waitingParams.childCount) }}
              </div>
              <!-- TB-14763: 인원 유형 사용 매장은 선택한 유형별 인원 노출 (추가 설명은 노출하지 않음) -->
              <div v-if="usePersonnelTypes" class="sub-wrap" :class="{ 'two-column': selectedPersonnelTypes.length >= 6 }">
                <div v-for="(type, idx) in selectedPersonnelTypes" :key="`${type.name}_${idx}`" class="item sub">
                  <div>{{ getMultiLanguageName(type, locale) }}</div>
                  {{ $tc('confirm_08_number_of_people', type.count) }}
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isNoRequestList" class="request_wrap">
            <div class="title" v-html="$tc('selectRequest')"></div>
            <hr class="divider">
            <div class="requests">
              <div v-for="request in clientRequestList" :key="request.idx" class="item"
              @click="selectRequest(request)">
                <div class="check-box" :class="{selected: request.isSelected}"></div>
                <div class="label">{{ getMultiLanguageName(request, locale) }}</div>
              </div>
            </div>
          </div>
          <!-- 메뉴정보 -->
          <div v-if="restaurant.menuRequired && selectedMenus.length > 0" class="menu-wrap">
            <div class="total-price">
              <div class="text">{{ $tc('orderAmount') }}</div>
              <div class="price">{{ $tc('won', selectedMenusTotalPrice) }}</div>
            </div>
            <hr class="divider">
            <div class="selected_menus">
              <div v-for="(menu, idx) in selectedMenus" :key="`${menu._id}_${idx}`" class="item">
                <div class="menu-name">
                    <text-ellipsis >{{ menu.name }}</text-ellipsis>
                    <div class="menu-quantity">{{ $tc('textOfOptionAddButton', menu.quantity) }}</div>
                </div>
                <div class="menu-size">{{ ` • ${$tc('size')}: ${menu.size.name} ${menu.size.price !== 0 ? `(${$tc('won', menu.size.price)})` : ''}` }}</div>
                <div v-show="(menu.options.length > 0)" class="menu-options">{{ ` • ${$tc('option')}: ${displayOptionsOneLine(menu)}` }}</div>
                <!-- <div class="selected_menu_title">
                  <div class="menu-name">
                    <text-ellipsis >{{ menu.name }}</text-ellipsis>
                  </div>
                  <div class="menu-quantity">{{ menu.quantity }}</div>
                </div>
                <div class="selected_menu_size">{{ ` • ${$tc('size')}: ${menu.size.name} ${menu.size.price !== 0 ? `(${$tc('won', menu.size.price)})` : ''}` }}</div>
                <div v-show="(menu.options.length > 0)" class="selected_menu_options">{{ ` • ${$tc('option')}: ${displayOptionsOneLine(menu)}` }}</div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-wrap">
        <div v-if="restaurantInfo.notice.confirm && !isExceptionStore" class="button" @click="showNotiPopup">
          <span>{{ $tc("confirm_04_add_queue") }}</span>
        </div>
        <div v-else class="button" @click.once="requestAddWaiting">
          <span>{{ $tc("confirm_04_add_queue") }}</span>
        </div>
      </div>
    </div>

    <popup v-show="showPopup" @popControl="popup" />
    <slot-popup v-show="showSlotPopup">
      <div class="icon" slot="icon">
        <img src="@/assets/img/caution-yellow.svg"/>
      </div>
      <div class="content" slot="content" v-html="errorMessage"></div>
      <div class="button_wrap" v-if="returnMenu" slot="button_wrap">
        <div class="button light_blue" @click="goMenuPage">{{ $tc('goMenuSelection') }}</div>
      </div>
      <div class="button_wrap" v-else slot="button_wrap">
        <div class="button" @click="() => { this.$router.push('/') }">{{ $tc('restart') }}</div>
      </div>
    </slot-popup>
    <div class="popup-wrap" v-show="isShowNotiPopup">
      <div class="noti-pop">
        <div class="contents-wrap">
          <div class="title">
            <img src="@/assets/Notice.svg" />
            <span>{{ noticePopupTitle }}</span>
          </div>
          <div class="text" v-html="restaurant.notice.confirm"></div>
        </div>
        <div class="button-wrap">
          <div class="button cancel" @click="() => { this.isShowNotiPopup = false }">{{ $tc('notice_popup_cancel') }}</div>
          <div class="button confirm" @click.once="requestAddWaiting">{{ $tc('notice_popup_confirm') }}</div>
        </div>
      </div>
    </div>
    <timeout-popup :isShow="isShowTimeOutPop" @moveToHome="moveToHome" @close="closeTimeoutPopup"/>
  </div>
</template>

<script>
import { timeout } from './mixins/timeout'
import { noticePopup } from './mixins/noticePopup'
import timeoutPopup from '@/components/TimeOutPopup.vue'
import { textEllipsis } from '@/components/text'
import { numberWidthComma, getMultiLanguageName, isUsePersonnelTypes, getCustomNameLabel, sortMenusByRestaurantOrder } from '../utills'
import { getRestaurantQuickMemo, addWaiting } from '@/api/waiting'
import popup from '@/components/Popup.vue'
import slotPopup from '@/components/SlotPopup'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ConfirmView',
  mixins: [timeout, noticePopup],
  components: { timeoutPopup, popup, slotPopup, textEllipsis
  },
  computed: {
    ...mapState(['restaurant', 'selectedClientRequest', 'locale', 'restaurantMenuInfo']),
    ...mapGetters({ waitingParams: 'getWaitingParams', restaurantInfo: 'getRestaurantInfo' }),
    displayDescriptionTitle () {
      return this.waitingParams.queueName ? this.$tc('confirm_02_description_title_use_queue', this.displayQueueName) : this.$tc('confirm_01_description_title')
    },
    displayQueueName () {
      const queueData = {
        name: this.waitingParams.queueName,
        multiLanguage: { name: this.waitingParams.queueNameMultiLanguage }
      }
      return getMultiLanguageName(queueData, this.locale)
    },
    isNoDisplayMenus () { // 메뉴 노출하지 않는 경우
      return this.locale !== 'ko' && ((this.restaurant.foreignRequestType && this.restaurant.foreignRequestType.length > 0 && this.waitingParams.email !== '') || this.restaurant.isNumTicket)
    },
    isExceptionStore () {
      return (process.env.VUE_APP_EXCEPTION_STORE && process.env.VUE_APP_EXCEPTION_STORE.includes(this.restaurantInfo.idx))
    },
    // TB-14763: 인원 유형 사용 매장 여부 (매장 설정 on + 인원 선택 화면에서 유형별 인원 저장됨)
    usePersonnelTypes () {
      return isUsePersonnelTypes(this.restaurant) && Array.isArray(this.waitingParams.personnelTypes) && this.waitingParams.personnelTypes.length > 0
    },
    // 선택 인원이 1명 이상인 인원 유형 목록 (표시용)
    selectedPersonnelTypes () {
      return (this.waitingParams.personnelTypes || []).filter(type => Number(type.count) > 0)
    },
    // 특정 매장은 이름 라벨을 커스텀 텍스트로 표기 (TB-14754, 병원 매장 "이름 / 생년월일")
    nameLabel () {
      return getCustomNameLabel(this.restaurantInfo.idx) || this.$tc('confirm_09_name')
    },
    // TB-14951: 인원 유형 미사용 매장은 총인원만 표기 (isChildOption 에 따른 성인/유아 구분은 제거)
    displayPeopleNum () {
      return `${this.$tc('confirm_07_number_of_personnel')} ${this.$tc('confirm_08_number_of_people', this.waitingParams.numOfPeople)}`
    },
    selectedMenusTotalPrice () {
      let totalPrice = 0
      this.selectedMenus.forEach(menu => {
        totalPrice = Number(totalPrice) + Number(menu.price * menu.quantity)
      })
      return numberWidthComma(totalPrice)
    },
    selectedMenusTotalQuantity () {
      let totalQuanty = 0
      this.selectedMenus.forEach(menu => {
        totalQuanty = Number(totalQuanty) + Number(menu.quantity)
      })
      return totalQuanty
    },
    isNoRequestList () {
      return (this.clientRequestList.length === 0)
    },
    displayPhoneNumber () {
      const phoneNumber = this.waitingParams.phoneNumber
      const middleNum = (phoneNumber.length >= 11) ? 4 : 3
      return `${phoneNumber.substr(0, 3)}-${phoneNumber.substr(3, middleNum)}-${phoneNumber.substr((3 + middleNum), phoneNumber.length)}`
    }
  },
  data () {
    return {
      isShowNotiPopup: false,
      selectedMenus: Array.from(this.$store.state.waitingParams.menus.values()),
      addWaitingBtnText: this.$tc('getWaitingNumber'),
      clientRequestList: [],
      showPopup: false,
      isAlert: false,
      showSlotPopup: false,
      returnMenu: false,
      errorMessage: ''
    }
  },
  methods: {
    getMultiLanguageName,
    /**
     * @description 확인용 공지사항 popup 노출
     * @returns {void}
     */
    showNotiPopup () {
      this.isShowNotiPopup = true
      // if (this.restaurantInfo.notice.confirm) {
      //   this.isShowNotiPopup = true
      // } else {
      //   this.requestAddWaiting()
      // }
    },
    displayOptionsOneLine (menu) {
      let optionsText = ''
      menu.options.forEach(option => {
        const qty = option.quantity || 1
        const name = (qty > 1) ? `${option.name} (${this.$tc('unitCount', qty)})` : option.name
        const linePrice = option.price * qty
        const price = (linePrice > 0) ? `+${this.$tc('won', linePrice)}` : this.$tc('won', linePrice)
        optionsText = (optionsText) ? `${optionsText} / ${name} (${price})` : `${name} (${price})`
      })
      return optionsText
    },
    requestAddWaiting () {
      this.isShowNotiPopup = false
      this.addWaitingBtnText = this.$tc('inProgress')
      const { nameRequired, phoneRequired, menuRequired } = this.restaurant
      const { name, phoneNumber, numOfPeople, isNoPhone, isMarketing, isThirdParty, childCount, queueIndex, email, tempKey, isPartnerInfoAgreement, isPartnerAdAgreement, personnelTypes } = this.waitingParams
      const guest = {}
      guest.locale = this.locale
      guest.isMarketing = isMarketing
      if (email) guest.email = email
      if (tempKey) guest.tempKey = tempKey
      if (name) guest.name = name
      if (phoneNumber) guest.phone = phoneNumber
      // if (isMarketing) guest.isMarketing = isMarketing
      if (isThirdParty) guest.isThirdParty = isThirdParty
      guest.isPartnerInfoAgreement = (isPartnerInfoAgreement != null) ? isPartnerInfoAgreement : false
      guest.isPartnerAdAgreement = (isPartnerAdAgreement != null) ? isPartnerAdAgreement : false
      let menus = []
      if (this.selectedMenus.length > 0) {
        // TB-14967: 화면(장바구니/주문서 확인)은 담은 순서를 유지하고,
        // 서버로 보내는 주문 메뉴만 매장이 설정한 메뉴 순서로 정렬한다.
        const sortedMenus = sortMenusByRestaurantOrder(this.selectedMenus, this.restaurantMenuInfo && this.restaurantMenuInfo.list)
        menus = sortedMenus.map(menu => {
          const { _id, name, price, isMain, isSoldOut, quantity } = menu
          const size = { name: menu.size.name, price: menu.size.price, _id: menu.size._id }
          const options = menu.options.map(option => {
            option.isSoldOut = false
            return option
          })
          return { _id, name, price, isMain, isSoldOut, quantity, size, options }
        })
      }
      const reservation = { numOfPeople, queueIndex }
      if (childCount) reservation.childCount = childCount
      // TB-14763: 인원 유형 사용 매장은 유형별 인원도 함께 전달 (numOfPeople/childCount 는 유형 합계)
      if (this.usePersonnelTypes) {
        reservation.personnelTypes = personnelTypes.map(({ name: typeName, count }) => ({ name: typeName, count: Number(count) || 0 }))
      }
      if (this.selectedClientRequest.size > 0) {
        let memo = ''
        for (const value of this.selectedClientRequest.values()) {
          memo = (memo.length > 0) ? `${memo} ${value}` : value
        }
        reservation.memo = memo
      }
      if (!(this.locale !== 'ko' && this.restaurant.foreignRequestType && this.restaurant.foreignRequestType.length > 0 && (email || tempKey))) {
        if (this.$store.state.local === 'ko' || !this.restaurant.isNumTicket) {
          if (nameRequired && (name === '')) {
            this.showValidationFailPopup()
            return
          }
          if (phoneRequired && phoneNumber === '') {
            if (!isNoPhone) {
              this.showValidationFailPopup()
              return
            }
          }
        }
      }
      // if ((this.restaurant.isCWType && this.restaurant.isRemoteWaitingOrderType && this.restaurant.isWType) && !((this.restaurant.isNumTicket && this.locale !== 'ko') || this.waitingParams.isNoPhone || this.waitingParams.email !== '') && menuRequired && (menus.length === 0)) {
      if ((this.restaurant.isWType && this.restaurant.menuRequired) && !((this.restaurant.isNumTicket && this.locale !== 'ko') || this.waitingParams.isNoPhone || this.waitingParams.email !== '' || this.waitingParams.tempKey !== '') && menuRequired && (menus.length === 0)) {
        this.errorMessage = this.$tc('emptyOrderMenuList')
        this.returnMenu = true
        this.showSlotPopup = true
        return
      }
      if (numOfPeople === 0) {
        this.showValidationFailPopup()
        return
      }
      const params = {
        restaurantIdx: this.$store.getters.getStoreIdx,
        waitingParams: {
          guest,
          reservation,
          menus
        }
      }
      addWaiting(params).then((res) => {
        const { data } = res
        this.$router.push(`/complete/${data.waitSequenceStatic}`)
        this.addWaitingBtnText = this.$tc('getWaitingNumber')
      }).catch((error) => {
        const { response } = error
        this.returnMenu = false

        if (response.status === 406 && response.data.error.code === 'DUPLICATED_PHONE') {
          this.errorMessage = this.$tc('already')
        } else if (response.status === 400) {
          switch (response.data.error.code) {
            case 'PLEASE_CHECK_AVAILABLE_QUANTITY':
              this.errorMessage = this.$tc('mainMenuQtyError')
              this.returnMenu = true
              break
            case 'BAD_ORDER_MENU':
              this.errorMessage = this.$tc('impossibleOrder')
              this.returnMenu = true
              break
            case 'SOLD_OUT_MENU':
              this.errorMessage = this.$tc('soldOutMenu')
              this.returnMenu = true
              break
            case 'PLEASE_CHECK_LIMIT_MENU_AVAILABLE_QUANTITY':
              this.errorMessage = this.$tc('limitMenuOver')
              this.returnMenu = true
              break
            case 'DAILY_OVER_QUANTITY':
              this.errorMessage = this.$tc('dailyQtyOver')
              this.returnMenu = true
              break
            case 'PLEASE_SELECT_MENU':
              this.errorMessage = this.$tc('emptyOrderMenuList')
              this.returnMenu = true
              break
            default:
              this.errorMessage = this.formatServerErrorMessage(response)
              this.returnMenu = false
          }
        } else {
          this.errorMessage = this.formatServerErrorMessage(response)
        }

        this.showSlotPopup = true
        this.addWaitingBtnText = this.$tc('getWaitingNumber')
      })
    },
    formatServerErrorMessage (response) {
      const errorCode = (response.data && response.data.error && response.data.error.code) || 'UNKNOWN'
      const errorMessage = (response.data && response.data.error && response.data.error.message) || ''
      return `${this.$tc('unexpectedError')}<br/><span style="font-size: 18px; color: #666;">Error Code: ${errorCode} </span>${errorMessage ? `<span style="font-size: 18px; color: #666;">${errorMessage}</span>` : ''}`
    },
    showValidationFailPopup (messageKey = 'unexpectedError') {
      this.errorMessage = this.$tc(messageKey)
      this.showSlotPopup = true
      this.returnMenu = false
    },
    goMenuPage () {
      // this.$router.push(`/menu`)
      this.$router.push({
        name: 'MenuView',
        params: { runValidate: true }
      })
    },
    // displayRequest () {
    //   let displayText = ''
    //   for (const value of this.selectedClientRequest.values()) {
    //     displayText = (displayText.length === 0) ? `${value}` : `${displayText}, ${value}`
    //   }
    //   return displayText || this.$tc('selectRequest')
    // },
    selectRequest (request) {
      console.log('request---', request)
      this.clientRequestList = this.clientRequestList.map((r) => {
        r.isSelected = (r._id === request._id) ? !r.isSelected : r.isSelected
        if (r.isSelected) {
          // 다국어 이름을 저장
          const requestName = getMultiLanguageName(r, this.locale)
          this.$store.commit('setSelectedClientRequest', { key: r._id, value: requestName })
        } else {
          this.$store.commit('deleteSelectedClientRequest', r._id)
        }
        return r
      })
    },
    goHome () {
      this.showPopup = true
    },
    popup (type) {
      console.debug('popup type---', type)
      if (type === 'cancle') {
        this.$router.push('/')
      } else {
        this.showPopup = false
      }
    },
    back () {
      let goPath = (this.restaurant.menuRequired) ? '/menu' : '/select-person'
      if (this.waitingParams.isNoPhone || this.isNoDisplayMenus) {
        goPath = 'select-person'
      }
      this.$router.push(goPath)
    }
  },
  async mounted () {
    // console.log('mounted---', this.selectedMenus)
    const { data } = await getRestaurantQuickMemo(this.$store.getters.getStoreIdx).catch((err) => {
      console.error('getRestaurantQuickMemo error---', err)
    })
    this.clientRequestList = data.map((memo) => {
      memo.isSelected = false
      return memo
    })
    // this.displayRequest()
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/base.scss";

.wrapper_dark {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.inner_wrap {
  display: flex;
  flex-direction: column;
  @include flex-gap(3.75vh, column);
  flex: 1;
  min-height: 0;
  .button-wrap {
    position: relative;
    width: 100%;
    height: 11.75vh;
    flex-shrink: 0;
    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 11.75vh;
      background: #D81B1B;
      color: #ffffff;
      font-size: 36px; // IE11 fallback
      font-size: unquote("min(4.5vh, 36px)");
      font-weight: 700;
      line-height: 1.055;
    }
  }
}
.contents-wrap {
  display: flex;
  width: 100%;
  flex: 1;
  min-height: 0;
}

// 메뉴, 요청사항중 한개만 사용하는 경우
.no-all-show {
  flex-direction: column;
  .info-wrap {
    display: flex;
    justify-content: center;
    @include flex-gap(1.5vh, row);
    padding: 0 3.125vw;
    flex: 1;
    min-height: 0;
    .customer-wrap {
      display: flex;
      flex-direction: column;
      @include flex-gap(3.5vh, column);
      flex-shrink: 0;
      height: fit-content;
      max-height: 100%; // TB-14763: 인원 유형이 많아 카드가 영역을 넘으면 카드 내부 스크롤
      overflow-y: auto;
      min-width: 800px;
      padding: 4vh 3.125vw;
      border-radius: 3vh;
      border: 1px solid #D7DBDF;
      background: $white;
      .item {
        display: flex;
        justify-content: space-between;
        color: #2E3137;
        font-size: 32px; // IE11 fallback
        font-size: unquote("min(4vh, 32px)");
        font-weight: 700;
        line-height: 1.125;
        &.name {
          div {
            flex-shrink: 0;
          }
          p {
            text-align: right;
          }
        }
      }
      .people-wrap {
        display: flex;
        flex-direction: column;
        @include flex-gap(2.5vh, column);
        .sub-wrap {
          display: flex;
          flex-direction: column;
          @include flex-gap(1.75vh, column);
          .sub {
            position: relative;
            padding: 0 0 0 2.34375vw;
            color: #6D7583;
            font-size: 28px; // IE11 fallback
            font-size: unquote("min(3.5vh, 28px)");
            font-weight: 600;
            line-height: 1.285;
            &::before {
              content: '•';
              position: absolute;
              left: 0.390625vw;
              color: #6D7583;
            }
          }
          // TB-14763: 인원 유형 항목이 많으면(6개) 2단 노출
          &.two-column {
            flex-direction: row;
            flex-wrap: wrap;
            > * + * {
              margin-top: 0;
            }
            .sub {
              width: calc(50% - 1.5vh);
              margin-bottom: 1.75vh;
              &:nth-child(odd) {
                margin-right: 3vh;
              }
            }
          }
        }
      }
      &.useFlex {
        min-width: 54.6875vw;
        height: auto;
      }
      // TB-14763: 인원 유형 사용 매장 표기 (Figma 5390-25682 / 5390-25849)
      &.useTypes {
        .item {
          font-size: 26px;
          line-height: 1.23;
        }
        .people-wrap .sub-wrap {
          @include flex-gap(12px, column);
          .sub {
            font-size: 24px;
            line-height: 1.583;
            &::before {
              line-height: 1.583;
            }
          }
          &.two-column {
            > * + * {
              margin-top: 0;
            }
            .sub {
              margin-bottom: 12px;
            }
          }
        }
      }
    }
  }
}

.description-wrap {
  display: flex;
  flex-direction: column;
  justify-content: center;
  @include flex-gap(2vh, column);
  padding: 5vh;
  text-align: center;
  .title {
    color: #000;
    font-size: 30px; // IE11 fallback
    font-size: unquote("min(3.75vw, 30px)");
    font-weight: 700;
    line-height: 1.133;
  }
  .body {
    color: #2E3137;
    text-align: center;
    font-size: 28px; // IE11 fallback
    font-size: unquote("min(3.5vh, 28px)");
    font-weight: 500;
    line-height: 1.285;
  }
}

.divider {
  margin: 0;
  height: 0.125vh;
  border-top: 1px solid #D7DBDF;
}

// 고객 요청 사항
.request_wrap {
  display: flex;
  flex-direction: column;
  @include flex-gap(2.5vh, column);
  flex: 1;
  flex-shrink: 0;
  // min-width: 38.12vw;
  padding: 28px 32px;
  border-radius: 24px;
  border: 1px solid #D7DBDF;
  background: $white;
  min-height: 0;
  .title {
    color: #2E3137;
    font-size: 28px; // IE11 fallback
    font-size: unquote("min(3.5vh, 28px)");
    font-weight: 700;
    line-height: 1.43;
    text-align: center;
  }
  .requests {
    display: flex;
    flex-direction: column;
    @include flex-gap(3vh, column);
    padding: 0 30px 0 0;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      display: block;
      width: 10px;
      background: #D7DBDF;
    }
    &::-webkit-scrollbar-thumb {
      background: #D7DBDF;
      border-radius: 10px;
    }
    .item {
      display: flex;
      @include flex-gap(1.5vh, row);
      font-size: 26px; // IE11 fallback
      font-size: unquote("min(3.25vh, 26px)");
      font-weight: 600;
      line-height: 1.38;
      word-break: break-all;
    }
    .check-box {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.5vw;
      height: 2.5vw;
      margin: 0.5vh;
      border-radius: 1vh;
      border: 1px solid #525965;
      background: $white;
      &.selected {
        background: #D81B1B;
        border: 1px solid #D81B1B;
      }
      &::after {
        content: '';
        display: block;
        width: 1.328125vw;
        height: 1.5vh;
        background: url('~@/assets/img/white/check.svg') no-repeat center center;
        background-size: 100% 100%;
      }
    }
  }
}
.menu-wrap {
  display: flex;
  flex-direction: column;
  @include flex-gap(20px, column);
  padding: 28px 32px;
  border: 1px solid #D7DBDF;
  border-radius: 24px;
  background: $white;
  /* overflow-y: auto; */
  flex: 1;
  min-width: 488px;
  min-height: 0;
  .total-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .text {
      color: #2E3137;
      font-size: 30px; // IE11 fallback
      font-size: unquote("min(3.75vw, 30px)");
      font-weight: 700;
      line-height: 4.5vh;
    }
    .price {
      color: #0091FF;
      font-size: 30px; // IE11 fallback
      font-size: unquote("min(3.75vw, 30px)");
      font-weight: 700;
      line-height: 38px;
    }
  }
  .selected_menus {
    display: flex;
    flex-direction: column;
    @include flex-gap(16px, column);
    padding: 0 16px 0 0;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    scrollbar-width: thin;
    &::-webkit-scrollbar {
      display: block;
      width: 0.3125vw;
    }
    &::-webkit-scrollbar-thumb {
      background: $gray_400;
      border-radius: 0.25vh;
    }
    .item {
      display: flex;
      flex-direction: column;
      @include flex-gap(4px, column);
      .menu-name {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include flex-gap(20px, row);
        p {
          max-width: calc(100% - 60px);
          color: #2E3137;
          font-size: 24px; // IE11 fallback
          font-size: unquote("min(3vh, 24px)");
          font-weight: 600;
          line-height: 1.333;
        }
        .menu-quantity {
          color: #2E3137;
          font-size: 24px; // IE11 fallback
          font-size: unquote("min(3vh, 24px)");
          font-weight: 400;
          line-height: 1.333;
          flex-shrink: 0;
        }
      }
      .menu-size, .menu-options {
        padding: 0 0 0 25px;
        text-indent: -15px;
        color: #6D7583;
        font-size: 20px; // IE11 fallback
        font-size: unquote("min(2.5vh, 20px)");
        font-weight: 500;
        line-height: 1.6;
        word-break: break-all;
      }
    }
  }
}
.all-show {
  flex-direction: row;
  @include flex-gap(1.5vh, row);
  padding: 3.75vh 3.125vw 0 3.125vw;
  .customer-and-menu-wrap {
    display: flex;
    flex-direction: row;
    @include flex-gap(12px, row);
    // width: 100%;
    .customer-wrap {
      display: flex;
      flex-direction: column;
      @include flex-gap(20px, column);
      padding: 32px;
      border: 1px solid #D7DBDF;
      border-radius: 24px;
      background: $white;
    }
    .description-wrap {
      @include flex-gap(6px, column);
      padding: 0;
      overflow: hidden;
      .title {
        font-size: 28px; // IE11 fallback
        font-size: unquote("min(3.5vh, 28px)");
        line-height: 1.28;
        text-align: left;
        color: #000;
      }
      .body {
        font-size: 24px; // IE11 fallback
        font-size: unquote("min(3vh, 24px)");
        line-height: 1.41;
        text-align: left;
      }
    }
    .customer-info {
      display: flex;
      align-items: center;
      // TB-14868: 형제 간격(flex-gap) 대신 구분선이 좌우 12px 간격을 담당
      // 이름이 비노출(display:none)이어도 전화번호가 좌측 정렬되고, 줄바꿈된 인원 유형도 이름과 좌측 정렬된다
      .vertical-divider {
        margin-left: 12px;
        margin-right: 12px;
      }
      padding: 14px 20px;
      border-radius: 12px;
      border: 1px solid #D7DBDF;
      background: #F8F9FA;
      color: #0091FF;
      text-align: center;
      font-size: 24px; // IE11 fallback
      font-size: unquote("min(3vh, 24px)");
      font-weight: 700;
      line-height: 1.41;
      .name {
        max-width: 15vh;
      }
      // TB-14763: 인원 유형 사용 매장 표기 (Figma 5390-25710 / 5395-26042)
      // 유형이 많아 한 줄에 못 들어가면 인원 영역을 전화번호 아래 줄로 내림
      &.wrap {
        flex-wrap: wrap;
        padding: 12px 20px;
        font-size: 22px;
        line-height: 34px;
        > * {
          margin-top: 2px;
          margin-bottom: 2px;
        }
        .people.types {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          text-align: left;
          .dot {
            margin: 0 4px;
            font-size: 24px;
          }
        }
      }
    }
    .menu-wrap {
      .total-price {
        .text, .price {
          font-size: 28px; // IE11 fallback
          font-size: unquote("min(3.5vh, 28px)");
          line-height: 1.285;
        }
      }
      .selected_menus {
        .item {
          .menu-name {
            p, .menu-quantity {
              font-size: 24px; // IE11 fallback
              font-size: unquote("min(3vh, 24px)");
              line-height: 1.33;
            }
          }
          .menu-size, .menu-options {
            font-size: 20px; // IE11 fallback
            font-size: unquote("min(2.5vh, 20px)");
            line-height: 1.6;
          }
        }
      }
    }
    &.useRequest {
      flex-direction: column;
      width: 100%;
      max-width: 58.6vw;
      @include flex-gap(12px, column);
      .menu-wrap {
        margin-left: 0;
      }
    }
  }
  .request_wrap {
    flex-shrink: 0;
    flex: 1;
    min-width: 0;
    min-height: 0;
    .title {
      font-size: 28px; // IE11 fallback
      font-size: unquote("min(3.5vh, 28px)");
      line-height: 1.428;
      color: #000;
    }
  }
}

.vertical-divider {
  width: 1px;
  height: 25px;
  border-left: 1px solid #B7BEC8;
}

.popup-wrap {
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  .noti-pop {
    display: flex;
    width: 850px;
    height: 660px;
    padding: 50px;
    flex-direction: column;
    align-items: flex-start;
    @include flex-gap(40px, column);
    border-radius: 32px;
    border: 1px solid #E0E0E0;
    background: $white;
    .contents-wrap {
      display: flex;
      flex-direction: column;
      @include flex-gap(28px, column);
      width: 100%;
      .title {
        display: flex;
        justify-content: center;
        align-items: center;
        @include flex-gap(16px, row);
        color: #000;
        font-size: 40px; // IE11 fallback
        font-size: unquote("min(3.125vw, 40px)");
        font-weight: 700;
        line-height: 54px;
        text-align: center;
      }
      .text {
        height: 344px;
        padding: 24px;
        border-radius: 24px;
        border: 1px solid #B7BEC8;
        background: #F8F9FA;
        overflow-y: auto;
        color: #131517;
        font-size: 24px; // IE11 fallback
        font-size: unquote("min(1.875vw, 24px)");
        font-weight: 600;
        line-height: 38px;
      }
    }
    .button-wrap {
      display: flex;
      @include flex-gap(20px, row);
      width: 100%;
      .button {
        display: flex;
        width: 100%;
        height: 94px;
        padding: 26px 10px;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        background: #E6E8EB;
        color: #2E3137;
        font-size: 32px; // IE11 fallback
        font-size: unquote("min(2.5vw, 32px)");
        font-weight: 700;
        line-height: 38px;
        cursor: pointer;
      }
      .confirm {
        background: #D81B1B;
        color: $white;
      }
    }
  }
}

</style>
